import SelectedNewsfeedsView from './SelectedNewsfeed';
import SelectedNewsfeedDetailView from './SelectedNewsfeedDetail';
import NewsfeedStudioEditorView from './studio/NewsfeedStudioEditor';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { renderHeaderButton } from '../../../store/headerButtonControl/duck';
import { updateUserDetails } from '../../../store/user/duck';

const SelectedNewsfeeds = connect(
  state => ({
    userDetails: state.user.userDetails,
    teamCampaignCodes: state.functions.campaignCodes,
    teams: state.team.teams
  }),
  {}
)(withRouter(injectIntl(SelectedNewsfeedsView)));

const SelectedNewsfeedDetail = connect(
  state => ({
    userDetails: state.user.userDetails,
    teamCampaignCodes: state.functions.campaignCodes,
    teams: state.team.teams
  }),
  {}
)(withRouter(injectIntl(SelectedNewsfeedDetailView)));

const SelectedNewsfeedStudio = connect(
  state => ({
    userDetails: state.user.userDetails,
    teamCampaignCodes: state.functions.campaignCodes,
    teams: state.team.teams
  }),
  {
    renderHeaderButton,
    updateUserDetails
  }
)(withRouter(injectIntl(NewsfeedStudioEditorView)));

export { SelectedNewsfeeds, SelectedNewsfeedDetail, SelectedNewsfeedStudio };
